import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { CalculatorSettingsService } from "../calculatorsettings/calculator-settings.service";

declare global {
    let BUILD_VERSION: string;
}

@Injectable({
    providedIn: "root"
})
export class EnvironmentService {

    constructor(private translate: TranslateService,
        private calculatorSettingsService: CalculatorSettingsService ) {

    }

    public isWidget(): boolean {
        return this.calculatorSettingsService.IsWidget() && !this.isProd();
    }

    public isProd(): boolean {
        if (environment.env) {
            return environment.env.toLocaleLowerCase() === "prd" || environment.env.toLocaleLowerCase() === "prod";
        }

        return false;
    }

    public getTitle(): string {
        let prefix = "";

        if (this.isWidget()) {
            prefix = "CEA " + environment.env + " ";
        }

        return prefix.toLocaleUpperCase() + this.translate.instant("START.HEADER.TITLE")
    }

    public getAddress(): string {
        return environment.address.split('\n').join("<br />");
    }

    public getVersion(): string {
        return BUILD_VERSION;
        //return environment.version;
    }

    public getRateSets(services: number[]): string {
        return services.join(",");
    }
    
}
